document.addEventListener('DOMContentLoaded', () => {
	let alertBlock = document.querySelector('[data-drupal-messages]');

	if (alertBlock != undefined) {
		let 
		text = 'Cerrar',
		id = 'data-drupal-messages--close',
		bodyClass = 'data-drupal-messages--hidden',
		html = `<button id="${id}" type="button"><span class="sr-only">${text}</span></button>`;
		
		alertBlock.insertAdjacentHTML('beforeend', html);
		
		let btn = document.getElementById(id);
		
		if (btn != undefined) {
			btn.addEventListener('click', e => {
				document.body.classList.add(bodyClass);
			})
		}
	}
});
